import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from 'src/components/TextField';

import { Popup } from 'src/components/Popup';
import { useOverrideSurveyResponseType } from 'src/hooks/job';
import s from './JobSurveyFalsification.styles';
import { SurveyUpdateWarningPopup } from './SurveyUpdateWarningPopup';

export const JobSurveyStatusPopup = ({
  onClose,
  onSubmit,
  response,
  selectedOverrideOption,
}) => {
  const { t } = useTranslation();
  const overrideSurveyResponseType = useOverrideSurveyResponseType();

  const [comment, setComment] = useState('');
  const [commentError, setCommentError] = useState(null);
  const [showSurveyUpdateWarning, setShowSurveyUpdateWarning] = useState(false);
  const [loading, setLoading] = useState(false);

  const responseTypeLabel =
    response.responseType === 'INVALID' ||
    response.responseType === 'MANUAL_INVALID'
      ? 'Invalid'
      : 'Valid';
  const selectedOverrideOptionLabel =
    selectedOverrideOption.value === 'MANUAL_INVALID' ? 'Invalid' : 'Valid';

  const onChangeStatus = () => {
    if (!comment) {
      setCommentError('Please enter override reason');
      return;
    }
    setCommentError(null);
    setShowSurveyUpdateWarning(true);
  };

  const submitResponse = async () => {
    setLoading(true);
    setShowSurveyUpdateWarning(false);
    await overrideSurveyResponseType({
      surveyResponseId: response?.id,
      responseType: selectedOverrideOption?.value,
      comment,
    });
    setLoading(false);
    onSubmit();
  };

  return (
    <>
      <Popup
        level={3}
        onClose={onClose}
        title={`Override ${responseTypeLabel} response`}
      >
        {(response.responseType === 'INVALID' ||
          response.responseType === 'MANUAL_INVALID') && (
          <>
            <s.Label space-below>
              The survey response is invalid because of following rules:
            </s.Label>
            <s.Label center space-below>
              <b>{response.invalidFalsificationRule}</b>
            </s.Label>
          </>
        )}
        <s.Label space-below>
          Please review the rules carefully before overriding and provide reason
          below.
        </s.Label>
        <TextField
          auth
          error={commentError}
          id="reason"
          label={'Reason for valid response override.'}
          multiline
          onChange={({ target }) => setComment(target.value)}
          required
          value={comment}
        />
        <s.PopupRow space-above>
          <s.Label>{`Override and mark as ${selectedOverrideOptionLabel}?`}</s.Label>
        </s.PopupRow>
        <s.PopupRow>
          <s.LinkButton
            disabled={loading}
            ghost
            onClick={onClose}
            red
            sm
            type="button"
          >
            {t('CANCEL')}
          </s.LinkButton>
          <s.ConfirmButton
            disabled={loading}
            onClick={e => {
              e.preventDefault();
              onChangeStatus();
            }}
            orange
            sm
            solid
          >
            {`Mark as ${selectedOverrideOptionLabel}`}
          </s.ConfirmButton>
        </s.PopupRow>
      </Popup>
      {showSurveyUpdateWarning && (
        <SurveyUpdateWarningPopup
          onClose={() => setShowSurveyUpdateWarning(false)}
          onSubmit={() => submitResponse()}
        />
      )}
    </>
  );
};
